export enum CMSBlocks {
    EDITOR_BLOCK = 'editor_block',
    EMBED = 'embed',
    ARTICLE = 'article',
    IMAGE = 'image',
    VIDEO = 'video',
}
